module.exports = __webpack_public_path__ + "static/media/homeBackground.3a9e19d2.png";